<template>
  <router-view />
</template>

<script>
export default {
  name: "FeedbackBase",
};
</script>

<style></style>
